import notificationsModule from '@/store/modules/notifications';

import { createNotificationEmitter } from './firebase';

export const initNotifications = async (): Promise<void> => {
    try {
        const emitter = await createNotificationEmitter();
        emitter?.subscribeToNotification(notificationsModule.showWithTimeout);
    } catch (error: unknown) {
        console.warn('Push notifications could not be initialized.', error);
    }
}
